import classnames from 'classnames';
import { MouseEventHandler, useCallback } from 'react';

import styles from './Chip.module.scss';
import { ChipProps } from './Chip.types';

export const Chip = ({
  size = 'medium',
  rounded = true,
  error,
  focus,
  selected,
  className,
  onClick,
  ...props
}: ChipProps) => {
  const handleClick = useCallback<MouseEventHandler<HTMLButtonElement>>(
    event => {
      const target = event.target as HTMLElement;
      if (target.matches(`button:not(.${styles.chip}), button:not(.${styles.chip}) *`))
        return event.preventDefault();
      onClick?.(event);
    },
    [onClick]
  );

  return (
    <button
      data-icon-size={size === 'small' ? 'xsmall' : size === 'medium' ? 'small' : 'medium'}
      className={classnames(styles.chip, className, styles[size], {
        [styles.error]: error,
        [styles.focus]: focus,
        [styles.rounded]: rounded,
        [styles.selected]: selected,
      })}
      type="button"
      onClick={handleClick}
      {...props}
    />
  );
};
